import sessionManager from '~/plugins/session-manager';
import { LOGIN } from '~/api/apolloCustomerMutations';
import { LOGOUT } from '~/api/apolloHeaderFooterMutations';
import { GET_CUSTOMER } from '~/api/apolloCommonQueries';
import { LocalScheme } from '~auth/runtime'; // eslint-disable-line

export default class GraphQLScheme extends LocalScheme {
  check() {
    const { user } = this.$auth.$state;
    const loggedIn = Boolean(user);
    return { valid: loggedIn };
  }

  async fetchUser() {
    try {
      const { customer } = await this.$auth.ctx.app.$graphql.default.request(GET_CUSTOMER) || {};
      if (!customer) {
        throw new Error('User data not found');
      }
      this.$auth.setUser(customer.me);
    } catch (error) {
      this.$auth.callOnError(error, { method: 'fetchUser' });
      throw error;
    }
  }

  async login({ username, password }) {
    try {
      const { customer: { login } } = await this.$auth.ctx.app.$graphql.default
        .request(LOGIN, { username, password }) || {};

      const { success } = login;

      if (success) {
        await this.fetchUser();
        sessionManager.updateData('checkout-settings', {
          current_step: 'address_step',
          delivery_saved: false,
        });
      }
      return login;
    } catch (error) {
      this.$auth.callOnError(error, { method: 'login' });
      return error;
    }
  }

  async logout() {
    try {
      const { customer: { logout } } = await this.$auth.ctx.app.$graphql.default.request(LOGOUT);
      const { success } = logout;
      if (success) {
        sessionManager.setData('checkout-settings', { current_step: 'address_step' });
        this.$auth.setUser(null);
      }
      const messageType = success ? 'successfully' : 'failed';
      this.$auth.ctx.store.commit('addMessage', {
        type: success ? 'success' : 'error',
        content: `You have ${messageType} signed out.`,
      });
      this.$auth.ctx.store.commit('listing/setWishList', []);
      this.$auth.ctx.store.commit('cart/setCart', null);
      return logout;
    } catch (error) {
      this.$auth.ctx.store.commit('addMessage', { type: 'error', content: 'You have failed signed out.' });
      this.$auth.callOnError(error, { method: 'logout' });
      return error;
    }
  }
}
